import { ReactComponent as WarningIcon } from 'assets/bosta-icons/Info-Circle.svg';
import { ReactComponent as OrdersIcon } from 'assets/bosta-icons/Orders.svg';

export const BUSINESS_TYPES = { B2B: 'B2B' };
export const BUSINESS_TIERS = { BRONZE: 'Bronze' };

export const BUSINESS_DOWNGRADE_STATES = {
  Normal: {
    string: 'Normal',
    icon: <OrdersIcon />,
    text_id: 'tracker_bar.business_upgrade_status.normal'
  },
  Warning: {
    string: 'Warning',
    icon: (
      <span className="br-downgrade__info-warning-icon">
        <WarningIcon />
      </span>
    ),
    text_id: 'tracker_bar.business_upgrade_status.warning'
  }
};
